import React, { useEffect, useState, useRef } from 'react';

const GMap = (props) => {
    const googleMapRef = useRef(null);
    let googleMap = null;

    const markerList = [
        // { lat: 59.2967322, lng: 18.0009393 },
        // { lat: 59.2980245, lng: 17.9971503 }
    ];

    const [, set_dados] = useState(null);
    const dados_map = useRef([]);

    const drawMarker = (obj) => {
        const marker = new window.google.maps.Marker({
            position: obj,
            map: googleMap
        });
        return marker;
    }

    const drawLine = (marker1, marker2) => {
        const line = new window.google.maps.Polyline({
            path: [marker1, marker2],
            map: googleMap
        });
        return line;
    }

    useEffect(() => {

        if(props.dados_coordenadas !== undefined && props.dados_coordenadas !== null && props.dados_coordenadas.length > 0) {
            set_dados(dados_map.current = props.dados_coordenadas)

            props.dados_coordenadas.forEach(el => {
                markerList.push({
                    lat: el.coordenadas.latitude,
                    lng: el.coordenadas.longitude,
                    hgl: el.highlight !== undefined ? el.highlight : false
                })
            });
        }

        googleMap = initGoogleMap();

        var bounds = new window.google.maps.LatLngBounds();
        markerList.map((x, k) => {
            // drawMarker(x)

            if(k === 0) {
                drawMarker(x)
            }
            if(x.hgl) {
                // console.log('#######', x)
                drawMarker(x)
            }

            if(markerList[k + 1] !== undefined && markerList[k + 1] !== null) {
                drawLine(markerList[k], markerList[k + 1])
            }
          
            bounds.extend(x);
        });
        googleMap.fitBounds(bounds);
        
    }, []);

    useEffect(() => {

        if(props.dados_coordenadas !== undefined && props.dados_coordenadas !== null && props.dados_coordenadas.length > 0) {
            set_dados(dados_map.current = props.dados_coordenadas)

            props.dados_coordenadas.forEach(el => {
                markerList.push({
                    lat: el.coordenadas.latitude,
                    lng: el.coordenadas.longitude,
                    hgl: el.highlight !== undefined ? el.highlight : false
                })
            });
        }

        console.log('googleMapRef.current', googleMapRef.current)
        console.log('window.google.maps', new window.google.maps.LatLngBounds())

        /*
        var bounds = new window.google.maps.LatLngBounds();
        console.log('bounds', bounds)

        markerList.map((x, k) => {

            if(x.hgl) {
                // console.log('#######', x)
                drawMarker(x)
            }
            bounds.extend(x);
        });
        console.log('bounds', bounds)
        */

        
        googleMap = initGoogleMap();
        console.log('googleMap', googleMap)


        var bounds = new window.google.maps.LatLngBounds();
        markerList.map((x, k) => {
            // drawMarker(x)

            if(k === 0) {
                drawMarker(x)
            }
            if(x.hgl) {
                // console.log('#######', x)
                drawMarker(x)
            }

            if(markerList[k + 1] !== undefined && markerList[k + 1] !== null) {
                drawLine(markerList[k], markerList[k + 1])
            }
          
            bounds.extend(x);
        });
        googleMap.fitBounds(bounds);

        
    }, [props.dados_coordenadas]);

    const initGoogleMap = () => {
        return new window.google.maps.Map(googleMapRef.current, {
            center: { lat: -34.397, lng: 150.644 },
            zoom: 8
        });
    }

    return <div
        ref={googleMapRef}
        style={{ width: '100%', height: '800px' }}
    />
}

export default GMap;